module.exports = __webpack_public_path__ + "static/media/MAZ.e39ccf79.png";